function initializeFileButtonListener(mbSizeLimit) {
  Array.from(document.querySelectorAll("[data-fv-file-upload-input]")).forEach(
    function (fileButton) {
      fileButton.onchange = function () {
        if (
          !this.files &&
          !Array.isArray(this.files) &&
          this.files.length > 0
        ) {
          console.error("Failure reading the file");
          return;
        }

        const file = this.files[0];
        const errorLabel = fileButton.parentElement.querySelector(
          "[data-fv-file-upload-error]"
        );
        const nameLabel = fileButton.parentElement.querySelector(
          "[data-fv-file-upload-name]"
        );

        if (errorLabel) {
          errorLabel.style.visibility = "hidden";
        }

        if (file.size > 1024 * 1024 * mbSizeLimit) {
          if (errorLabel) {
            errorLabel.style.visibility = "visible";
          }
          this.value = "";
          console.error(
            "The file " + file.name + " is bigger than " + mbSizeLimit + " MBs"
          );
          if (nameLabel) {
            nameLabel.style.visibility = "hidden";
          }
          return;
        }

        if (nameLabel) {
          nameLabel.style.visibility = "visible";
          nameLabel.innerHTML = file.name;
        }
      };
    }
  );
}

function initializeChangeToNoneListener() {
  Array.from(document.querySelectorAll("[data-fv-check-none]")).forEach(
    function (selector) {
      selector.onchange = function (event) {
        let shouldDisplay;
        const tag = event.target.tagName || "";

        switch (tag.toLowerCase()) {
          case "input":
            shouldDisplay = event.target.checked;
            break;
          case "select":
          default:
            shouldDisplay = event.target.value === "none";
        }

        const target = selector.getAttribute("data-fv-check-none-target");
        Array.from(document.querySelectorAll("[" + target + "]")).forEach(
          function (element) {
            if (shouldDisplay) {
              element.classList.remove("hidden-field");
            } else {
              element.classList.add("hidden-field");
            }
          }
        );
      };
    }
  );
}

initializeFileButtonListener(5); // 5 MB LIMIT
initializeChangeToNoneListener();
